import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 16.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("linearGradient", {
      id: "i1064727727__a",
      gradientUnits: "userSpaceOnUse",
      x1: "0",
      y1: "-6.235",
      x2: "50",
      y2: "-6.235",
      gradientTransform: "matrix(1 0 0 -1 0 1.83)"
    }, [
      _createElementVNode("stop", {
        offset: "0",
        style: {"stop-color":"#272357"}
      }),
      _createElementVNode("stop", {
        offset: "1",
        style: {"stop-color":"#194491"}
      })
    ], -1),
    _createElementVNode("path", {
      fill: "url(#i1064727727__a)",
      d: "m19 .3-6.6 15.6H8.2L5 3.4c-.1-.6-.4-1.1-1-1.3C2.7 1.5 1.4 1 0 .7L.1.2H7c.9 0 1.7.7 1.8 1.6l1.7 9L14.7.2H19zm16.7 10.5c0-4.1-5.7-4.3-5.7-6.2 0-.6.5-1.2 1.7-1.3 1.4-.1 2.8.1 4 .7l.7-3.3C35.3.2 34 0 32.7 0c-4 0-6.8 2.1-6.8 5.2 0 2.2 2 3.5 3.5 4.2s2.1 1.3 2.1 1.9c0 1.1-1.3 1.5-2.4 1.5-1.4 0-2.9-.3-4.1-1l-.7 3.4c1.4.6 3 .8 4.5.8 4.1.1 6.9-2 6.9-5.2m10.5 5.1H50L46.7.3h-3.5c-.8 0-1.4.4-1.7 1.1l-6.1 14.5h4.2l.8-2.3h5.2l.6 2.3zm-4.5-5.5 2.1-5.9 1.2 5.9h-3.3zM24.8.3l-3.3 15.6h-4L20.8.3h4z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "visa"}) } }